import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment';
import './TableGridExperiences.css';
import {labels, statusTypes} from "../../util/constants";
import {generalConfig} from "../../util/config";

let propsG = [];

const options = {
    onRowClick: (row)=>{ redirectToExperience(row)},
};

const redirectToExperience = (row) =>{
    if(row.status_label != statusTypes.canceled){
        propsG.redirectToExperience(row)
    }
};

const formatDate = (cell,row)=>{
    return moment(cell).format(generalConfig.dateFormat);
};

const addClassNameColumn = (fieldValue, row, rowIdx, colIdx) => {
    if(row.status_label != statusTypes.canceled){
        return 'pointer';
    }
};

const parseStatus = (cell, row) =>{
    return cell == statusTypes.sent ? statusTypes.received : cell;
};

const selectRow = { };//todo - hover color

const TableGridExperience = (props) => {
    propsG = props;
    return(
        <div className="div-margin-top col-15">
                <BootstrapTable width data={props.data} options={options} striped hover
                                condensed pagination selectRow={ selectRow } >
                    <TableHeaderColumn dataField="id_user" editable={false} isKey columnClassName={addClassNameColumn}
                                       dataAlign='center' > {labels.registration} </TableHeaderColumn>
                    <TableHeaderColumn width={'15%'} dataField="user_name" dataAlign='center' editable={false} columnClassName={addClassNameColumn}
                                       dataSort> {labels.name} </TableHeaderColumn>
                    <TableHeaderColumn width={'10%'} dataField="profile_type"  editable={false} columnClassName={addClassNameColumn}
                                        dataAlign='center'> {labels.profile} </TableHeaderColumn>
                    <TableHeaderColumn dataField="license_plate"  dataAlign='center' editable={false} columnClassName={addClassNameColumn}
                                       > {labels.plateVehicle} </TableHeaderColumn>
                    <TableHeaderColumn width={'10%'} dataField="model_car"  dataAlign='center' editable={false} columnClassName={addClassNameColumn}
                                        > {labels.model} </TableHeaderColumn>
                    <TableHeaderColumn   dataField="market"  dataAlign='center' editable={false} columnClassName={addClassNameColumn}
                                       > {labels.market} </TableHeaderColumn>
                    <TableHeaderColumn  width={'15%'} dataField="claimed_name_pt"  editable={false} columnClassName={addClassNameColumn}
                                        dataAlign='center'> {labels.claimedItem} </TableHeaderColumn>
                    <TableHeaderColumn  dataField="creation_date"  editable={false} dataFormat={formatDate} columnClassName={addClassNameColumn}
                                        dataAlign='center' dataSort> {labels.creationDate} </TableHeaderColumn>
                    <TableHeaderColumn  dataField="status_label"  editable={false} columnClassName={addClassNameColumn} dataFormat={parseStatus}
                                        dataAlign='center'> {labels.status} </TableHeaderColumn>
                    <TableHeaderColumn  dataField="update_date"  editable={false} dataFormat={formatDate} columnClassName={addClassNameColumn}
                                        dataAlign='center' dataSort> {labels.statusDate} </TableHeaderColumn>
                </BootstrapTable>
        </div>
    );
};

export default TableGridExperience;


// WEBPACK FOOTER //
// ./src/components/TableGridExperiences/TableGridExperiences.js